<mat-toolbar color="primary">
  <button *ngIf="me" mat-icon-button
          (click)="onMenuClick()">
    <mat-icon>menu</mat-icon>
  </button>
  <span class="app-name">Система тестирования</span>
  <span class="spacer"></span>
  <button *ngIf="me"
          [matMenuTriggerFor]="profileMenu"
          mat-icon-button
          matTooltip="Профиль">
    <mat-icon>account_circle</mat-icon>
  </button>
</mat-toolbar>
<mat-menu #profileMenu="matMenu" class="bar-profile-menu">
  <div class="user-name"
       [matTooltip]="formatFullFio()">{{formatFio()}}</div>
  <a mat-menu-item
     [routerLink]="['/me']">
    <mat-icon>account_circle</mat-icon>
    <span>Профиль</span>
  </a>
  <button mat-menu-item
          (click)="logout()">
    <mat-icon>logout</mat-icon>
    <span>Выйти</span>
  </button>
</mat-menu>
